export interface IDashMedicineUseHistory {
    
}